/* globals
    rscpCfg,
    Control,
    Debug,
    ConvertIso8601TimeSpanToHundredths,
    GetDateFromUtcIso8601Time,
    ConvertHundredthsToIso8601TimeSpan,
    RESULT_UNKNOWN,
    DATA_STATE_DIRTY,
    DATA_STATE_POSTED
*/
/* eslint-disable camelcase, new-cap */
function Activity (
    DatabaseId,
    ItemIdentifier,
    ScormObjectDatabaseId,
    ActivityProgressStatus,
    ActivityAttemptCount,
    AttemptProgressStatus,
    AttemptCompletionAmountStatus,
    AttemptCompletionAmount,
    AttemptCompletionStatus,
    Active,
    Suspended,
    Included,
    Ordinal,
    SelectedChildren,
    RandomizedChildren,
    ActivityObjectives,
    RunTime,
    PrevAttemptProgressStatus,
    PrevAttemptCompletionStatus,
    AttemptedDuringThisAttempt,
    FirstCompletionTimestampUtc,
    ActivityStartTimestampUtc,
    AttemptStartTimestampUtc,
    ActivityAbsoluteDuration,
    AttemptAbsoluteDuration,
    ActivityExperiencedDurationTracked,
    AttemptExperiencedDurationTracked,
    ActivityExperiencedDurationReported,
    AttemptExperiencedDurationReported,
    AiccSessionId
) {
    /* globals DATA_STATE_CLEAN */

    // this is here purely to make this object easier to identify in the Quick Watch debugger window.
    // It is initialized by the activity repository.
    this.StringIdentifier = null;

    // data initialized from server
    this.DatabaseId = DatabaseId;
    this.ItemIdentifier = ItemIdentifier;
    this.ScormObjectDatabaseId = ScormObjectDatabaseId;

    this.ActivityProgressStatus = ActivityProgressStatus;
    this.ActivityAttemptCount = ActivityAttemptCount;
    this.AttemptProgressStatus = AttemptProgressStatus;
    this.AttemptCompletionAmountStatus = AttemptCompletionAmountStatus;
    this.AttemptCompletionAmount = AttemptCompletionAmount;
    this.AttemptCompletionStatus = AttemptCompletionStatus;
    this.Active = Active;
    this.Suspended = Suspended;
    this.Included = Included;
    this.Ordinal = Ordinal;
    this.SelectedChildren = SelectedChildren;
    this.RandomizedChildren = RandomizedChildren;

    this.ActivityObjectives = ActivityObjectives;
    this.RunTime = RunTime;

    this.PrevAttemptProgressStatus = PrevAttemptProgressStatus;
    this.PrevAttemptCompletionStatus = PrevAttemptCompletionStatus;
    this.AttemptedDuringThisAttempt = AttemptedDuringThisAttempt;

    this.FirstCompletionTimestampUtc = FirstCompletionTimestampUtc;

    // NOTE: these timestamps are stored as strings. Make sure they 'sort' correctly so that rollup
    // works by simple string comparison
    this.ActivityStartTimestampUtc = ActivityStartTimestampUtc;
    this.AttemptStartTimestampUtc = AttemptStartTimestampUtc;

    this.ActivityAbsoluteDuration = ActivityAbsoluteDuration;
    this.AttemptAbsoluteDuration = AttemptAbsoluteDuration;
    this.ActivityExperiencedDurationTracked = ActivityExperiencedDurationTracked;
    this.AttemptExperiencedDurationTracked = AttemptExperiencedDurationTracked;
    this.ActivityExperiencedDurationReported = ActivityExperiencedDurationReported;
    this.AttemptExperiencedDurationReported = AttemptExperiencedDurationReported;

    this.AiccSessionId = AiccSessionId;

    // If ActivityAbsoluteDuration is negative then we know that this registration launched
    // before support for these durations was available.  In this case the runtime never
    // sends back fields
    this.IsDurations = ConvertIso8601TimeSpanToHundredths(ActivityAbsoluteDuration) >= 0;

    // set when we close out this acitivity.  Helpful when rolling up
    // durations to detect 'child activity last exited'
    this.ActivityEndedDate = null;

    // data initialized on client side
    this.Sequencer = null;
    this.LookAheadActivity = false;
    this.LearningObject = null;
    this.ParentActivity = null;
    // maintain as an array indexed by integers, int indicies are used by selection and randomization
    this.ChildActivities = [];
    this.AvailableChildren = null;

    this.DataState = DATA_STATE_CLEAN;

    this.MenuItem = null;

    this.CachedPrimaryObjective = null;
    this.HiddenFromChoice = false;

    // used by the scorm 2004 look ahead sequencer
    this.HasSeqRulesRelevantToChoice = null;
    this.HasChildActivitiesDeliverableViaFlow = false;

    // indicates whether this activity has been shown to the end user, i.e, the sco/asset's initial
    // html page has been shown
    this.LaunchedThisSession = false;
}

/* eslint-disable no-use-before-define */
Activity.prototype.GetXml = Activity_GetXml;
Activity.prototype.toString = Activity_toString;
Activity.prototype.GetTitle = Activity_GetTitle;
Activity.prototype.GetItemIdentifier = Activity_GetItemIdentifier;
Activity.prototype.GetDatabaseIdentifier = Activity_GetDatabaseIdentifier;
Activity.prototype.GetLaunchPath = Activity_GetLaunchPath;
Activity.prototype.IsDeliverable = Activity_IsDeliverable;
Activity.prototype.TransferRteDataToActivity = Activity_TransferRteDataToActivity;
Activity.prototype.IsTheRoot = Activity_IsTheRoot;
Activity.prototype.IsALeaf = Activity_IsALeaf;
Activity.prototype.IsActive = Activity_IsActive;
Activity.prototype.IsSuspended = Activity_IsSuspended;
Activity.prototype.HasSuspendedChildren = Activity_HasSuspendedChildren;
Activity.prototype.SetActive = Activity_SetActive;
Activity.prototype.SetSuspended = Activity_SetSuspended;
Activity.prototype.IsTracked = Activity_IsTracked;
Activity.prototype.IsCompletionSetByContent = Activity_IsCompletionSetByContent;
Activity.prototype.IsObjectiveSetByContent = Activity_IsObjectiveSetByContent;
Activity.prototype.GetAttemptProgressStatus = Activity_GetAttemptProgressStatus;
Activity.prototype.SetAttemptProgressStatus = Activity_SetAttemptProgressStatus;
Activity.prototype.SetAttemptCompletionStatus = Activity_SetAttemptCompletionStatus;
Activity.prototype.GetAttemptCompletionStatus = Activity_GetAttemptCompletionStatus;
Activity.prototype.GetChildren = Activity_GetChildren;
Activity.prototype.GetSequencingControlFlow = Activity_GetSequencingControlFlow;
Activity.prototype.GetSequencingControlChoice = Activity_GetSequencingControlChoice;
Activity.prototype.GetSequencingControlChoiceExit = Activity_GetSequencingControlChoiceExit;
Activity.prototype.GetSequencingControlForwardOnly = Activity_GetSequencingControlForwardOnly;
Activity.prototype.GetPreventActivation = Activity_GetPreventActivation;
Activity.prototype.GetConstrainedChoice = Activity_GetConstrainedChoice;
Activity.prototype.GetSelectionTiming = Activity_GetSelectionTiming;
Activity.prototype.GetSelectionCountStatus = Activity_GetSelectionCountStatus;
Activity.prototype.GetSelectionCount = Activity_GetSelectionCount;
Activity.prototype.GetRandomizationTiming = Activity_GetRandomizationTiming;
Activity.prototype.GetRandomizeChildren = Activity_GetRandomizeChildren;
Activity.prototype.GetLimitConditionAttemptControl = Activity_GetLimitConditionAttemptControl;
Activity.prototype.GetActivityProgressStatus = Activity_GetActivityProgressStatus;
Activity.prototype.SetActivityProgressStatus = Activity_SetActivityProgressStatus;
Activity.prototype.GetAttemptCount = Activity_GetAttemptCount;
Activity.prototype.GetLimitConditionAttemptLimit = Activity_GetLimitConditionAttemptLimit;
Activity.prototype.GetPreConditionRules = Activity_GetPreConditionRules;
Activity.prototype.GetPostConditionRules = Activity_GetPostConditionRules;
Activity.prototype.GetExitRules = Activity_GetExitRules;
Activity.prototype.IsSatisfied = Activity_IsSatisfied;
Activity.prototype.IsObjectiveStatusKnown = Activity_IsObjectiveStatusKnown;
Activity.prototype.IsObjectiveMeasureKnown = Activity_IsObjectiveMeasureKnown;
Activity.prototype.IsObjectiveMeasureGreaterThan = Activity_IsObjectiveMeasureGreaterThan;
Activity.prototype.IsObjectiveMeasureLessThan = Activity_IsObjectiveMeasureLessThan;
Activity.prototype.GetObjectiveMeasure = Activity_GetObjectiveMeasure;
Activity.prototype.IsCompleted = Activity_IsCompleted;
Activity.prototype.IsActivityProgressKnown = Activity_IsActivityProgressKnown;
Activity.prototype.IsAttempted = Activity_IsAttempted;
Activity.prototype.IsAttemptLimitExceeded = Activity_IsAttemptLimitExceeded;
Activity.prototype.GetObjectives = Activity_GetObjectives;
Activity.prototype.FindObjective = Activity_FindObjective;
Activity.prototype.GetPrimaryObjective = Activity_GetPrimaryObjective;
Activity.prototype.GetRollupObjectiveMeasureWeight = Activity_GetRollupObjectiveMeasureWeight;
Activity.prototype.GetMeasureSatisfactionIfActive = Activity_GetMeasureSatisfactionIfActive;
Activity.prototype.GetRollupRules = Activity_GetRollupRules;
Activity.prototype.ApplyRollupRule = Activity_ApplyRollupRule;
Activity.prototype.GetRollupObjectiveSatisfied = Activity_GetRollupObjectiveSatisfied;
Activity.prototype.GetRequiredForSatisfied = Activity_GetRequiredForSatisfied;
Activity.prototype.GetRequiredForNotSatisfied = Activity_GetRequiredForNotSatisfied;
Activity.prototype.RollupProgressCompletion = Activity_RollupProgressCompletion;
Activity.prototype.GetRequiredForCompleted = Activity_GetRequiredForCompleted;
Activity.prototype.GetRequiredForIncomplete = Activity_GetRequiredForIncomplete;
Activity.prototype.IncrementAttemptCount = Activity_IncrementAttemptCount;
Activity.prototype.SetRandomizedChildren = Activity_SetRandomizedChildren;
Activity.prototype.SetSelectedChildren = Activity_SetSelectedChildren;
Activity.prototype.GetRandomizedChildren = Activity_GetRandomizedChildren;
Activity.prototype.GetSelectedChildren = Activity_GetSelectedChildren;
Activity.prototype.GetActivityListBetweenChildren = Activity_GetActivityListBetweenChildren;
Activity.prototype.IsActivityAnAvailableChild = Activity_IsActivityAnAvailableChild;
Activity.prototype.IsActivityAnAvailableDescendent = Activity_IsActivityAnAvailableDescendent;
Activity.prototype.IsActivityTheLastAvailableChild = Activity_IsActivityTheLastAvailableChild;
Activity.prototype.IsActivityTheFirstAvailableChild = Activity_IsActivityTheFirstAvailableChild;
Activity.prototype.GetFirstAvailableChild = Activity_GetFirstAvailableChild;
Activity.prototype.GetNextActivityPreorder = Activity_GetNextActivityPreorder;
Activity.prototype.GetPreviousActivityPreorder = Activity_GetPreviousActivityPreorder;
Activity.prototype.GetNextSibling = Activity_GetNextSibling;
Activity.prototype.GetPreviousSibling = Activity_GetPreviousSibling;
Activity.prototype.InitializeAvailableChildren = Activity_InitializeAvailableChildren;
Activity.prototype.GetAvailableChildren = Activity_GetAvailableChildren;
// Activity.prototype.GetUnAvailableChildren = Activity_GetUnAvailableChildren;
Activity.prototype.SetAvailableChildren = Activity_SetAvailableChildren;
Activity.prototype.IsAvailable = Activity_IsAvailable;
// Activity.prototype.InitializeObjectives = Activity_InitializeObjectives;
Activity.prototype.InitializeForNewAttempt = Activity_InitializeForNewAttempt;
Activity.prototype.ResetAttemptState = Activity_ResetAttemptState;
Activity.prototype.RollupDurations = Activity_RollupDurations;
Activity.prototype.SetDirtyData = Activity_SetDirtyData;
Activity.prototype.IsAnythingDirty = Activity_IsAnythingDirty;
Activity.prototype.MarkPostedObjectiveDataDirty = Activity_MarkPostedObjectiveDataDirty;
Activity.prototype.MarkPostedObjectiveDataClean = Activity_MarkPostedObjectiveDataClean;
Activity.prototype.MarkDirtyObjectiveDataPosted = Activity_MarkDirtyObjectiveDataPosted;
Activity.prototype.SetSequencer = Activity_SetSequencer;
Activity.prototype.Clone = Activity_Clone;
Activity.prototype.TearDown = Activity_TearDown;
Activity.prototype.DisplayInChoice = Activity_DisplayInChoice;
Activity.prototype.SetHiddenFromChoice = Activity_SetHiddenFromChoice;
Activity.prototype.SetLaunchedThisSession = Activity_SetLaunchedThisSession;
Activity.prototype.WasLaunchedThisSession = Activity_WasLaunchedThisSession;
Activity.prototype.SetAttemptedDuringThisAttempt = Activity_SetAttemptedDuringThisAttempt;
Activity.prototype.WasAttemptedDuringThisAttempt = Activity_WasAttemptedDuringThisAttempt;
Activity.prototype.GetMinProgressMeasure = Activity_GetMinProgressMeasure;
Activity.prototype.GetCompletionProgressWeight = Activity_GetCompletionProgressWeight;
Activity.prototype.GetCompletedByMeasure = Activity_GetCompletedByMeasure;
Activity.prototype.GetAttemptCompletionAmount = Activity_GetAttemptCompletionAmount;
Activity.prototype.SetAttemptCompletionAmount = Activity_SetAttemptCompletionAmount;
Activity.prototype.GetAttemptCompletionAmountStatus = Activity_GetAttemptCompletionAmountStatus;
Activity.prototype.SetAttemptCompletionAmountStatus = Activity_SetAttemptCompletionAmountStatus;
Activity.prototype.GetCompletionStatusChangedDuringRuntime = Activity_GetCompletionStatusChangedDuringRuntime;
Activity.prototype.GetSuccessStatusChangedDuringRuntime = Activity_GetSuccessStatusChangedDuringRuntime;
Activity.prototype.GetActivityStartTimestampUtc = Activity_GetActivityStartTimestampUtc;
Activity.prototype.SetActivityStartTimestampUtc = Activity_SetActivityStartTimestampUtc;
Activity.prototype.GetAttemptStartTimestampUtc = Activity_GetAttemptStartTimestampUtc;
Activity.prototype.SetAttemptStartTimestampUtc = Activity_SetAttemptStartTimestampUtc;
Activity.prototype.GetActivityAbsoluteDuration = Activity_GetActivityAbsoluteDuration;
Activity.prototype.SetActivityAbsoluteDuration = Activity_SetActivityAbsoluteDuration;
Activity.prototype.GetAttemptAbsoluteDuration = Activity_GetAttemptAbsoluteDuration;
Activity.prototype.SetAttemptAbsoluteDuration = Activity_SetAttemptAbsoluteDuration;
Activity.prototype.GetActivityExperiencedDurationTracked = Activity_GetActivityExperiencedDurationTracked;
Activity.prototype.SetActivityExperiencedDurationTracked = Activity_SetActivityExperiencedDurationTracked;
Activity.prototype.GetAttemptExperiencedDurationTracked = Activity_GetAttemptExperiencedDurationTracked;
Activity.prototype.SetAttemptExperiencedDurationTracked = Activity_SetAttemptExperiencedDurationTracked;
Activity.prototype.GetActivityExperiencedDurationReported = Activity_GetActivityExperiencedDurationReported;
Activity.prototype.SetActivityExperiencedDurationReported = Activity_SetActivityExperiencedDurationReported;
Activity.prototype.GetAttemptExperiencedDurationReported = Activity_GetAttemptExperiencedDurationReported;
Activity.prototype.SetAttemptExperiencedDurationReported = Activity_SetAttemptExperiencedDurationReported;
Activity.prototype.UsesDefaultSatisfactionRollupRules = Activity_UsesDefaultSatisfactionRollupRules;
Activity.prototype.UsesDefaultCompletionRollupRules = Activity_UsesDefaultCompletionRollupRules;
/* eslint-enable no-use-before-define */

function Activity_GetXml () {
    /* globals ServerFormater, XmlElement */
    var ServerFormat = new ServerFormater(),
        xml = new XmlElement("A"),
        i;

    xml.AddAttribute("DI", this.DatabaseId);
    xml.AddAttribute("II", this.ItemIdentifier);

    xml.AddAttribute("APS", ServerFormat.ConvertBoolean(this.ActivityProgressStatus));

    xml.AddAttribute("AAC", this.ActivityAttemptCount);

    xml.AddAttribute("AtPS", ServerFormat.ConvertBoolean(this.AttemptProgressStatus));
    xml.AddAttribute("ACS", ServerFormat.ConvertBoolean(this.AttemptCompletionStatus));

    xml.AddAttribute("ACAS", ServerFormat.ConvertBoolean(this.AttemptCompletionAmountStatus));
    xml.AddAttribute("ACA", this.AttemptCompletionAmount);

    xml.AddAttribute("A", ServerFormat.ConvertBoolean(this.Active));
    xml.AddAttribute("S", ServerFormat.ConvertBoolean(this.Suspended));
    xml.AddAttribute("I", ServerFormat.ConvertBoolean(this.Included));
    xml.AddAttribute("O", this.Ordinal);
    xml.AddAttribute("SC", ServerFormat.ConvertBoolean(this.SelectedChildren));
    xml.AddAttribute("RC", ServerFormat.ConvertBoolean(this.RandomizedChildren));

    xml.AddAttribute("PAPS", ServerFormat.ConvertBoolean(this.PrevAttemptProgressStatus));
    xml.AddAttribute("PACS", ServerFormat.ConvertBoolean(this.PrevAttemptCompletionStatus));
    xml.AddAttribute("ADTA", ServerFormat.ConvertBoolean(this.AttemptedDuringThisAttempt));

    if (this.FirstCompletionTimestampUtc !== null) {
        xml.AddAttribute("FCTU", this.FirstCompletionTimestampUtc);
    }

    //
    // If ActivityAbsoluteDuration is negative then we know that this registration launched
    // before support for these durations was available.  In this case the runtime never
    // sends back fields
    //
    if (this.IsDurations) {
        if (this.ActivityStartTimestampUtc !== null) {
            xml.AddAttribute("ASTU", this.ActivityStartTimestampUtc);
        }
        if (this.AttemptStartTimestampUtc !== null) {
            xml.AddAttribute("AtSTU", this.AttemptStartTimestampUtc);
        }

        xml.AddAttribute("AAD", ServerFormat.ConvertTimeSpan(this.ActivityAbsoluteDuration));
        xml.AddAttribute("AtAD", ServerFormat.ConvertTimeSpan(this.AttemptAbsoluteDuration));
        xml.AddAttribute("AEDT", ServerFormat.ConvertTimeSpan(this.ActivityExperiencedDurationTracked));
        xml.AddAttribute("AtEDT", ServerFormat.ConvertTimeSpan(this.AttemptExperiencedDurationTracked));
        xml.AddAttribute("AEDR", ServerFormat.ConvertTimeSpan(this.ActivityExperiencedDurationReported));
        xml.AddAttribute("AtEDR", ServerFormat.ConvertTimeSpan(this.AttemptExperiencedDurationReported));
    }

    for (i = 0; i < this.ActivityObjectives.length; i += 1) {
        xml.AddElement(this.ActivityObjectives[i].GetXml(this.DatabaseId, i));
    }

    if (this.RunTime !== null) {
        xml.AddElement(this.RunTime.GetXml(this.DatabaseId));
    }

    //
    // we're intentionally not getting the XML for all the child activities...only want to submit
    // what is dirty and no more
    //

    return xml.toString();
}

function Activity_toString () {
    return this.GetTitle() + " (" + this.GetItemIdentifier() + ")";
}

function Activity_GetTitle () {
    return this.LearningObject.Title;
}

function Activity_GetItemIdentifier () {
    //
    // In SCORM 1.1 / 1.2 if the item identifier is null or "" or something...we need this to be intelligent enough
    // to return the DB id or something to ensure that other functionality which depends on this (such as DIV names) doesn't break
    //
    if (this.LearningObject.ItemIdentifier !== null && this.LearningObject.ItemIdentifier !== "") {
        return this.LearningObject.ItemIdentifier;
    }

    return this.DatabaseId;
}

function Activity_GetDatabaseIdentifier () {
    return this.DatabaseId;
}

function Activity_GetLaunchPath () {
    /* globals MergeQueryStringParameters */
    return MergeQueryStringParameters(this.LearningObject.Href, this.LearningObject.Parameters);
}

function Activity_IsDeliverable () {
    return this.RunTime !== null;
}

// eslint-disable-next-line complexity
function Activity_TransferRteDataToActivity () {
    /* globals
        SCORM_STATUS_UNKNOWN,
        SCORM_STATUS_PASSED,
        SCORM_STATUS_FAILED,
        SCORM_STATUS_NOT_ATTEMPTED,
        SCORM_STATUS_COMPLETED,
        SCORM_STATUS_INCOMPLETE,
        SCORM_STATUS_BROWSED,
        SCORE_ROLLUP_METHOD_AVERAGE_SCORE_OF_ALL_UNITS_WITH_NONZERO_SCORES,
        NormalizeRawScore
    */
    var objectives = this.GetObjectives(),
        rtObjective,
        primaryObjective = this.GetPrimaryObjective(),
        primaryObjectiveProgressMeasureSet = false,
        id,
        i,
        successStatus,
        completionStatus,
        objComplStatus,
        objComplStatusValue,
        normalizedScore,
        attemptProgressStatus,
        attemptCompletionStatus;

    if (this.IsTracked()) {
        for (i = 0; i < objectives.length; i += 1) {
            id = objectives[i].GetIdentifier();

            rtObjective = this.RunTime.FindObjectiveWithId(id);

            // rt.objective.success_status goes to seq.objective.objective satisfied status / seq.objective.objective progress status
            if (rtObjective !== null) {
                // only save data to the activity tree if it was changed during this runtime session
                // we don't want to resave this data to the activity tree if it doesn't change at runtime, that would give a
                // local objective known status, even though it was populated from a global objective

                if (rtObjective.SuccessStatusChangedDuringRuntime === true) {
                    // eslint-disable-next-line max-depth
                    if (rtObjective.SuccessStatus === SCORM_STATUS_UNKNOWN) {
                        objectives[i].SetProgressStatus(false, false, this, true);
                    }
                    else if (rtObjective.SuccessStatus === SCORM_STATUS_PASSED) {
                        objectives[i].SetProgressStatus(true, false, this, true);
                        objectives[i].SetSatisfiedStatus(true, false, this);
                    }
                    else if (rtObjective.SuccessStatus === SCORM_STATUS_FAILED) {
                        objectives[i].SetProgressStatus(true, false, this, true);
                        objectives[i].SetSatisfiedStatus(false, false, this);
                    }
                    else {
                        Debug.AssertError("Invalid success status (" + rtObjective.SuccessStatus + ") encountered in a RTE objective at position " + i);
                    }
                }

                if (rtObjective.MeasureChangedDuringRuntime === true) {
                    // objectives.score.scaled -> seq.objective measure status / seq.objective.normalized measure
                    if (rtObjective.ScoreScaled === null) {
                        objectives[i].SetMeasureStatus(false, this);
                    }
                    else {
                        objectives[i].SetMeasureStatus(true, this);
                        objectives[i].SetNormalizedMeasure(rtObjective.ScoreScaled, this);
                    }
                }

                // Can we just blindly copy these properties
                objectives[i].SetScoreRaw(rtObjective.ScoreRaw);
                objectives[i].SetScoreMin(rtObjective.ScoreMin);
                objectives[i].SetScoreMax(rtObjective.ScoreMax);

                if (rtObjective.ProgressMeasureChangedDuringRuntime === true) {
                    if (primaryObjective.GetIdentifier() === id) {
                        primaryObjectiveProgressMeasureSet = true;

                        if (rtObjective.ProgressMeasure === null) {
                            this.SetAttemptCompletionAmountStatus(false);
                        }
                        else {
                            this.SetAttemptCompletionAmountStatus(true);
                            this.SetAttemptCompletionAmount(rtObjective.ProgressMeasure);
                        }
                    }

                    if (rtObjective.ProgressMeasure === null) {
                        objectives[i].SetProgressMeasureStatus(false);
                    }
                    else {
                        objectives[i].SetProgressMeasureStatus(true);
                        objectives[i].SetProgressMeasure(rtObjective.ProgressMeasure);
                    }
                }
                if (rtObjective.CompletionStatusChangedDuringRuntime === true) {
                    objComplStatus = false;
                    objComplStatusValue = false;

                    if (rtObjective.CompletionStatus === SCORM_STATUS_UNKNOWN) {
                        objComplStatus = false;
                    }
                    else if (rtObjective.CompletionStatus === SCORM_STATUS_NOT_ATTEMPTED) {
                        objComplStatus = true;
                        objComplStatusValue = false;
                    }
                    else if (rtObjective.CompletionStatus === SCORM_STATUS_COMPLETED) {
                        objComplStatus = true;
                        objComplStatusValue = true;
                    }
                    else if (rtObjective.CompletionStatus === SCORM_STATUS_INCOMPLETE) {
                        objComplStatus = true;
                        objComplStatusValue = false;
                    }
                    else if (rtObjective.CompletionStatus === SCORM_STATUS_BROWSED) {
                        objComplStatus = true;
                        objComplStatusValue = false;
                    }
                    else {
                        Debug.AssertError("Invalid completion status-" + rtObjective.CompletionStatus);
                    }

                    objectives[i].SetCompletionStatus(objComplStatus);
                    if (objComplStatus === true) {
                        objectives[i].SetCompletionStatusValue(objComplStatusValue);
                    }

                    if (primaryObjective.GetIdentifier() === id) {
                        this.SetAttemptProgressStatus(objComplStatus);
                        if (objComplStatus === true) {
                            this.SetAttemptCompletionStatus(objComplStatusValue);
                        }
                    }
                }
            }
            // there might be a primary objective with no id in here
            else if (id.length > 0) {
                Debug.AssertError("Sequencing objective not found in runtime, id=" + objectives[i].GetIdentifier());
            }
        }

        // rt.success status goes to objective progress status, objective satisfied status

        if (this.Sequencer.LookAhead === true) {
            successStatus = this.RunTime.LookAheadSuccessStatus;
            completionStatus = this.RunTime.LookAheadCompletionStatus;
        }
        else {
            successStatus = this.RunTime.SuccessStatus;
            completionStatus = this.RunTime.CompletionStatus;
        }

        if (successStatus === SCORM_STATUS_UNKNOWN) {
            primaryObjective.SetProgressStatus(false, false, this);
        }
        else if (successStatus === SCORM_STATUS_PASSED) {
            primaryObjective.SetProgressStatus(true, false, this);
            primaryObjective.SetSatisfiedStatus(true, false, this);
        }
        else if (successStatus === SCORM_STATUS_FAILED) {
            primaryObjective.SetProgressStatus(true, false, this);
            primaryObjective.SetSatisfiedStatus(false, false, this);
        }
        else {
            this.Sequencer.LogSeq("ERROR - invalid success status-" + successStatus);
        }

        // Don't transfer score data if the score is zero and and the rudamentary rollup says
        // not to count zero scores. By utilizing the package property here, we prevent the zero
        // scores from getting onto the objective data.
        if (this.RunTime.ScoreRaw === 0 && Control.Package.Properties.ScoreRollupMode === SCORE_ROLLUP_METHOD_AVERAGE_SCORE_OF_ALL_UNITS_WITH_NONZERO_SCORES) {
            // Do nothing with score
        }
        else if (this.RunTime.ScoreScaled === null) {
            // rt.score.scaled goes to objective measure status / objective normalized measure
            primaryObjective.SetMeasureStatus(false, this);

            if (Control.Package.Properties.ScaleRawScore === true) {
                normalizedScore = NormalizeRawScore(this.RunTime.ScoreRaw, this.RunTime.ScoreMin, this.RunTime.ScoreMax);
                if (typeof normalizedScore !== "undefined" && normalizedScore !== null) {
                    primaryObjective.SetMeasureStatus(true, this);
                    primaryObjective.SetNormalizedMeasure(normalizedScore, this);
                }
                else {
                    this.Sequencer.LogSeq("WARNING - Unable to normalize score - Raw Score: " + this.RunTime.ScoreRaw + "Min Score: " + this.RunTime.ScoreMin + "Max Score: " + this.RunTime.ScoreMax);
                }
            }
            // if scalerawscore property is true
            //     if runtime.scoreraw is not null
            //       normalize / scale raw score if possible
            //           if was able to normalize raw score
            //               set measure status to true
            //               set normalized measure to normalized raw score
            //          if not able to normalize score write warning to debug log
        }
        else {
            primaryObjective.SetMeasureStatus(true, this);
            primaryObjective.SetNormalizedMeasure(this.RunTime.ScoreScaled, this);
        }

        // Can we just blindly copy these properties
        primaryObjective.SetScoreRaw(this.RunTime.ScoreRaw);
        primaryObjective.SetScoreMin(this.RunTime.ScoreMin);
        primaryObjective.SetScoreMax(this.RunTime.ScoreMax);

        if (this.RunTime.ProgressMeasure === null) {
            if (primaryObjectiveProgressMeasureSet !== true) {
                this.SetAttemptCompletionAmountStatus(false);
                primaryObjective.SetProgressMeasureStatus(false);
            }
        }
        else {
            this.SetAttemptCompletionAmountStatus(true);
            this.SetAttemptCompletionAmount(this.RunTime.ProgressMeasure);

            primaryObjective.SetProgressMeasureStatus(true);
            primaryObjective.SetProgressMeasure(this.RunTime.ProgressMeasure);
        }

        attemptProgressStatus = false;
        attemptCompletionStatus = false;

        //
        // There appears to be instances where this flag is false yet we actually need to transfer RT status
        // to the Activity data. What's the problem with always doing this? It appears this check was put
        // in place specifically to handle a 4th edition requirement so only using the flag in that case.
        //
        if (Control.Package.LearningStandard.is20044thOrGreater() === false || this.RunTime.CompletionStatusChangedDuringRuntime === true) {
            // completion status -> AttemptProgressStatus / AttemptCompletionStatus
            if (completionStatus === SCORM_STATUS_UNKNOWN) {
                attemptProgressStatus = false;
                attemptCompletionStatus = false;
            }
            else if (completionStatus === SCORM_STATUS_NOT_ATTEMPTED) {
                attemptProgressStatus = true;
                attemptCompletionStatus = false;
            }
            else if (completionStatus === SCORM_STATUS_COMPLETED) {
                attemptProgressStatus = true;
                attemptCompletionStatus = true;
            }
            else if (completionStatus === SCORM_STATUS_INCOMPLETE) {
                attemptProgressStatus = true;
                attemptCompletionStatus = false;
            }
            else if (completionStatus === SCORM_STATUS_BROWSED) {
                attemptProgressStatus = true;
                attemptCompletionStatus = false;
            }
            else {
                Debug.AssertError("Invalid completion status-" + completionStatus);
            }

            this.SetAttemptProgressStatus(attemptProgressStatus);
            if (attemptProgressStatus === true) {
                this.SetAttemptCompletionStatus(attemptCompletionStatus);
            }
        }

        if (this.LookAheadActivity === false) {
            // make sure that all this get committed
            this.SetDirtyData();
        }
    }
    else {
        // this.LogSeq("Not tracked...not transfering RTE data");
    }
}

function Activity_IsTheRoot () {
    var parentActivity = this.ParentActivity,
        activityIsRoot = parentActivity === null;

    return activityIsRoot;
}

function Activity_IsALeaf () {
    if (this.ChildActivities.length === 0) {
        return true;
    }

    return false;
}

function Activity_IsActive () {
    return this.Active;
}

function Activity_IsSuspended () {
    return this.Suspended;
}

function Activity_HasSuspendedChildren () {
    var children = this.GetChildren(),
        i;

    for (i = 0; i < children.length; i += 1) {
        if (children[i].IsSuspended()) {
            return true;
        }
    }

    return false;
}

function Activity_SetActive (active) {
    this.Active = active;
    this.SetDirtyData();
}

function Activity_SetSuspended (suspended) {
    this.Suspended = suspended;
    this.SetDirtyData();
}

function Activity_IsTracked () {
    return this.LearningObject.SequencingData.Tracked;
}

function Activity_IsCompletionSetByContent () {
    var completionSet = false;

    if (Control.Package.Properties.ForceObjectiveCompletionSetByContent === true) {
        completionSet = true;
    }
    else {
        completionSet = this.LearningObject.SequencingData.CompletionSetByContent;
    }

    return completionSet;
}

function Activity_IsObjectiveSetByContent () {
    var objectiveSet = false;

    if (Control.Package.Properties.ForceObjectiveCompletionSetByContent === true) {
        objectiveSet = true;
    }
    else {
        objectiveSet = this.LearningObject.SequencingData.ObjectiveSetByContent;
    }

    return objectiveSet;
}

function Activity_GetAttemptProgressStatus () {
    if (this.IsTracked() === false) {
        return false;
    }

    return this.AttemptProgressStatus;
}

function Activity_SetAttemptProgressStatus (value) {
    this.AttemptProgressStatus = value;

    if (value === true) {
        this.SetAttemptedDuringThisAttempt();
    }

    this.GetPrimaryObjective().SetCompletionStatus(value);
    this.SetDirtyData();
}

function Activity_SetAttemptCompletionStatus (value) {
    /* globals ConvertDateToIso8601String */
    if (this.FirstCompletionTimestampUtc === null && value === true) {
        this.FirstCompletionTimestampUtc = ConvertDateToIso8601String(new Date());
    }

    this.AttemptCompletionStatus = value;

    this.GetPrimaryObjective().SetCompletionStatusValue(value);
    this.SetDirtyData();
}

function Activity_GetAttemptCompletionStatus () {
    if (this.IsTracked() === false) {
        return false;
    }

    return this.AttemptCompletionStatus;
}

function Activity_GetChildren () {
    return this.ChildActivities;
}

function Activity_GetSequencingControlFlow () {
    return this.LearningObject.SequencingData.ControlFlow;
}

function Activity_GetSequencingControlChoice () {
    return this.LearningObject.SequencingData.ControlChoice;
}

function Activity_GetSequencingControlChoiceExit () {
    return this.LearningObject.SequencingData.ControlChoiceExit;
}

function Activity_GetSequencingControlForwardOnly () {
    return this.LearningObject.SequencingData.ControlForwardOnly;
}

function Activity_GetPreventActivation () {
    return this.LearningObject.SequencingData.PreventActivation;
}

function Activity_GetConstrainedChoice () {
    return this.LearningObject.SequencingData.ConstrainChoice;
}

function Activity_GetSelectionTiming () {
    return this.LearningObject.SequencingData.SelectionTiming;
}

function Activity_GetSelectionCountStatus () {
    return this.LearningObject.SequencingData.SelectionCountStatus;
}

function Activity_GetSelectionCount () {
    return this.LearningObject.SequencingData.SelectionCount;
}

function Activity_GetRandomizationTiming () {
    return this.LearningObject.SequencingData.RandomizationTiming;
}

function Activity_GetRandomizeChildren () {
    return this.LearningObject.SequencingData.RandomizeChildren;
}

function Activity_GetLimitConditionAttemptControl () {
    return this.LearningObject.SequencingData.LimitConditionAttemptControl;
}

function Activity_GetActivityProgressStatus () {
    if (this.IsTracked() === false) {
        return false;
    }

    return this.ActivityProgressStatus;
}

function Activity_SetActivityProgressStatus (status) {
    this.ActivityProgressStatus = status;
    this.SetDirtyData();
}

function Activity_GetAttemptCount () {
    return this.ActivityAttemptCount;
}

function Activity_GetLimitConditionAttemptLimit () {
    return this.LearningObject.SequencingData.LimitConditionAttemptLimit;
}

function Activity_GetPreConditionRules () {
    return this.LearningObject.SequencingData.PreConditionSequencingRules;
}

function Activity_GetPostConditionRules () {
    return this.LearningObject.SequencingData.PostConditionSequencingRules;
}

function Activity_GetExitRules () {
    return this.LearningObject.SequencingData.ExitSequencingRules;
}

function Activity_IsSatisfied (referencedObjective, canLookAtPreviousAttempt) {
    var objective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        // don't throw an error because this is called from integrations that were in place before
        // we added this parameter for 3rd Edition
        canLookAtPreviousAttempt = false;
    }

    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    if (typeof referencedObjective === "undefined" || referencedObjective === null || referencedObjective === "") {
        objective = this.GetPrimaryObjective();
    }
    else {
        objective = this.FindObjective(referencedObjective);
    }

    if (typeof objective === "undefined" || objective === null) {
        Debug.AssertError("Sequencing rule references a bad objective.");
    }

    if (objective.GetProgressStatus(this, canLookAtPreviousAttempt) === true) {
        if (objective.GetSatisfiedStatus(this, canLookAtPreviousAttempt) === true) {
            return true;
        }

        return false;
    }

    return RESULT_UNKNOWN;
}

function Activity_IsObjectiveStatusKnown (referencedObjective, canLookAtPreviousAttempt) {
    var objective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into IsObjectiveStatusKnown");
    }

    if (this.IsTracked() === false) {
        return false;
    }

    objective = this.FindObjective(referencedObjective);

    if (objective.GetProgressStatus(this, canLookAtPreviousAttempt) === true) {
        return true;
    }

    return false;
}

function Activity_IsObjectiveMeasureKnown (referencedObjective, canLookAtPreviousAttempt) {
    var objective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into IsObjectiveMeasureKnown");
    }

    if (this.IsTracked() === false) {
        return false;
    }

    objective = this.FindObjective(referencedObjective);

    //
    // change made to be consistent with Addendum 3.4 of SCORM 2004 2nd Edition
    // if (objective.GetProgressStatus(this) === true && objective.GetMeasureStatus() === true){
    //
    if (objective.GetMeasureStatus(this, canLookAtPreviousAttempt) === true) {
        return true;
    }

    return false;
}

function Activity_IsObjectiveMeasureGreaterThan (referencedObjective, measureThreshold, canLookAtPreviousAttempt) {
    var objective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into IsObjectiveMeasureGreaterThan");
    }

    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    objective = this.FindObjective(referencedObjective);

    if (objective.GetMeasureStatus(this, canLookAtPreviousAttempt) === true) {
        if (objective.GetNormalizedMeasure(this, canLookAtPreviousAttempt) > measureThreshold) {
            return true;
        }

        return false;
    }

    return RESULT_UNKNOWN;
}

function Activity_IsObjectiveMeasureLessThan (referencedObjective, measureThreshold, canLookAtPreviousAttempt) {
    var objective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into IsObjectiveMeasureLessThan");
    }

    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    objective = this.FindObjective(referencedObjective);

    Debug.AssertError("The objective referenced by a sequencing rule was not found. Does the definition of the sequencing rule in the manifest erroneously reference the name of the global objective instead of the local name of the objective? Problematic reference=" + referencedObjective, objective === null);

    if (objective.GetMeasureStatus(this, canLookAtPreviousAttempt) === true) {
        if (objective.GetNormalizedMeasure(this, canLookAtPreviousAttempt) < measureThreshold) {
            return true;
        }

        return false;
    }

    return RESULT_UNKNOWN;
}

function Activity_GetObjectiveMeasure (canLookAtPreviousAttempt) {
    var objective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetObjectiveMeasure");
    }

    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    objective = this.GetPrimaryObjective();

    if (objective.GetMeasureStatus(this, canLookAtPreviousAttempt) === true) {
        return objective.GetNormalizedMeasure(this, canLookAtPreviousAttempt);
    }

    return RESULT_UNKNOWN;
}

// eslint-disable-next-line complexity
function Activity_IsCompleted (referencedObjective, canLookAtPreviousAttempt) {
    var useObjectiveValues = false,
        useProgressMeasureValues = false,
        attemptProgressStatus,
        attemptCompletionStatus,
        progressMeasureStatus,
        progressMeasure,
        objective = null,
        primaryObjective,
        readCompletionMaps;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        // don't throw an error because this is called from integrations that were in place before
        // we added this parameter for 3rd Edition
        canLookAtPreviousAttempt = false;
    }

    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    if (Control.Package.LearningStandard.is20044thOrGreater()) {
        useObjectiveValues = true;
    }

    if (Control.Package.LearningStandard.is20044thOrGreater() === true && this.GetCompletedByMeasure() === true) {
        useProgressMeasureValues = true;
    }

    if (useObjectiveValues === true && typeof referencedObjective !== "undefined" && referencedObjective !== null && referencedObjective !== "") {
        objective = this.FindObjective(referencedObjective);

        if (typeof objective === "undefined" || objective === null) {
            Debug.AssertError("Sequencing rule references a bad objective.");
        }
    }

    // first, try the referenced objective
    if (useObjectiveValues === true && typeof objective !== "undefined" && objective !== null) {
        attemptProgressStatus = objective.GetCompletionStatus(this, canLookAtPreviousAttempt);
        attemptCompletionStatus = objective.GetCompletionStatusValue(this, canLookAtPreviousAttempt);

        if (useProgressMeasureValues === true) {
            progressMeasureStatus = objective.GetProgressMeasureStatus();
            progressMeasure = objective.GetProgressMeasure();
        }
    }
    else {
        // next, try the primary objective if there are readCompletion maps
        primaryObjective = this.GetPrimaryObjective();
        readCompletionMaps = primaryObjective.GetMaps("ReadCompletionStatus", true);

        if (useObjectiveValues === true && readCompletionMaps.length > 0) {
            attemptProgressStatus = primaryObjective.GetCompletionStatus(this, canLookAtPreviousAttempt);
            attemptCompletionStatus = primaryObjective.GetCompletionStatusValue(this, canLookAtPreviousAttempt);

            if (useProgressMeasureValues === true) {
                progressMeasureStatus = primaryObjective.GetProgressMeasureStatus();
                progressMeasure = primaryObjective.GetProgressMeasure();
            }
        }
        else {
            // otherwise, use the activity completion status

            //
            // when evaluating sequencing rules, if there was a previous attempt, and the current
            // activity hasn't been attempted during the current attempt on the parent, use the
            // previous attempt's data
            //
            if (canLookAtPreviousAttempt === true && this.WasAttemptedDuringThisAttempt() === false) {
                attemptProgressStatus = this.PrevAttemptProgressStatus;
                attemptCompletionStatus = this.PrevAttemptCompletionStatus;
            }
            else {
                attemptProgressStatus = this.AttemptProgressStatus;
                attemptCompletionStatus = this.AttemptCompletionStatus;
            }

            if (useProgressMeasureValues === true) {
                progressMeasureStatus = this.GetAttemptCompletionAmountStatus();
                progressMeasure = this.GetAttemptCompletionAmount();
            }
        }
    }

    if (useProgressMeasureValues === true && (this.IsActive() === false || this.GetMeasureSatisfactionIfActive() === true)) {
        if (progressMeasureStatus === true) {
            if (progressMeasure >= this.GetMinProgressMeasure()) {
                return true;
            }

            return false;
        }

        return RESULT_UNKNOWN;
    }

    if (attemptProgressStatus === true) {
        if (attemptCompletionStatus === true) {
            return true;
        }

        return false;
    }

    return RESULT_UNKNOWN;
}

// eslint-disable-next-line complexity
function Activity_IsActivityProgressKnown (referencedObjective, canLookAtPreviousAttempt) {
    var useObjectiveValues = false,
        activityProgressStatus = this.ActivityProgressStatus,
        attemptProgressStatus,
        objective = null,
        primaryObjective,
        readCompletionMaps;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into IsActivityProgressKnown");
    }

    if (this.IsTracked() === false) {
        return false;
    }

    if (Control.Package.LearningStandard.is20044thOrGreater()) {
        useObjectiveValues = true;
    }

    if (Control.Package.LearningStandard.is20044thOrGreater() === true && this.GetCompletedByMeasure() === true) {
        attemptProgressStatus = this.GetAttemptCompletionAmountStatus();
    }
    else {
        if (useObjectiveValues === true && typeof referencedObjective !== "undefined" && referencedObjective !== null && referencedObjective !== "") {
            objective = this.FindObjective(referencedObjective);

            if (typeof objective === "undefined" || objective === null) {
                Debug.AssertError("Sequencing rule references a bad objective.");
            }
        }

        if (useObjectiveValues === true && typeof objective !== "undefined" && objective !== null) {
            attemptProgressStatus = objective.GetCompletionStatus(this, canLookAtPreviousAttempt);
        }
        else {
            // next, try the primary objective if there are readCompletion maps
            primaryObjective = this.GetPrimaryObjective();
            readCompletionMaps = primaryObjective.GetMaps("ReadCompletionStatus", true);

            if (useObjectiveValues === true && readCompletionMaps.length > 0) {
                attemptProgressStatus = primaryObjective.GetCompletionStatus(this, canLookAtPreviousAttempt);
            }
            else if (canLookAtPreviousAttempt === true && this.WasAttemptedDuringThisAttempt() === false) {
                attemptProgressStatus = this.PrevAttemptProgressStatus;
            }
            else {
                attemptProgressStatus = this.AttemptProgressStatus;
            }
        }
    }

    if (useObjectiveValues === true) {
        return attemptProgressStatus;
    }

    return attemptProgressStatus === true && activityProgressStatus === true;
}

function Activity_IsAttempted () {
    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    if (this.ActivityProgressStatus === true || Control.Package.LearningStandard.is20044thOrGreater() === true) {
        if (this.GetAttemptCount() > 0) {
            return true;
        }
    }

    return RESULT_UNKNOWN;
}

function Activity_IsAttemptLimitExceeded () {
    if (this.IsTracked() === false) {
        return RESULT_UNKNOWN;
    }

    // [UP.1]2. If the Activity is Active for the activity is True Or the Activity is Suspended for the
    // activity is True Then (Only need to check activities that will begin a new attempt)
    if (this.IsActive() || this.IsSuspended()) {
        return false;
    }

    // TODO: if LimitConditionAttemptControl === false, do we return false or unknown? is it unknown
    //       b/c (true && unknown) == unknown?

    if (this.ActivityProgressStatus === true && this.GetLimitConditionAttemptControl() === true && this.GetAttemptCount() >= this.GetLimitConditionAttemptLimit()) {
        return true;
    }

    return RESULT_UNKNOWN;
}

function Activity_GetObjectives () {
    return this.ActivityObjectives;
}

function Activity_FindObjective (objectiveIdentifier) {
    // if the identifer is null or "", returns the primaryObjective
    var objectives = this.GetObjectives(),
        i;

    for (i = 0; i < objectives.length; i += 1) {
        if (objectiveIdentifier === null || objectiveIdentifier === "") {
            if (objectives[i].GetContributesToRollup() === true) {
                return objectives[i];
            }
        }
        else if (objectives[i].GetIdentifier() === objectiveIdentifier) {
            return objectives[i];
        }
    }

    return null;
}

function Activity_GetPrimaryObjective () {
    var targetObjective = null,
        objectives,
        i;

    if (this.CachedPrimaryObjective === null) {
        objectives = this.GetObjectives();

        for (i = 0; i < objectives.length; i += 1) {
            if (objectives[i].GetContributesToRollup() === true) {
                targetObjective = objectives[i];
                break;
            }
        }

        this.CachedPrimaryObjective = targetObjective;
    }

    if (this.CachedPrimaryObjective === null) {
        Debug.AssertError("Could not find a primary objective.");
    }

    return this.CachedPrimaryObjective;
}

function Activity_GetRollupObjectiveMeasureWeight () {
    return parseFloat(this.LearningObject.SequencingData.RollupObjectiveMeasureWeight);
}

function Activity_GetMeasureSatisfactionIfActive () {
    return this.LearningObject.SequencingData.MeasureSatisfactionIfActive;
}

function Activity_GetRollupRules () {
    return this.LearningObject.SequencingData.RollupRules;
}

function Activity_ApplyRollupRule (newRollupRule) {
    /* globals RULE_SET_SATISFIED, RULE_SET_NOT_SATISFIED */
    var newRuleIdx;

    if (newRollupRule.Action === RULE_SET_SATISFIED || newRollupRule.Action === RULE_SET_NOT_SATISFIED) {
        this.LearningObject.UsesDefaultSatisfactionRollupRules = true;
    }
    else {
        this.LearningObject.UsesDefaultCompletionRollupRules = true;
    }

    newRuleIdx = this.LearningObject.SequencingData.RollupRules.length;
    this.LearningObject.SequencingData.RollupRules[newRuleIdx] = newRollupRule;
}

function Activity_GetRollupObjectiveSatisfied () {
    return this.LearningObject.SequencingData.RollupObjectiveSatisfied;
}

function Activity_GetRequiredForSatisfied () {
    return this.LearningObject.SequencingData.RequiredForSatisfied;
}

function Activity_GetRequiredForNotSatisfied () {
    return this.LearningObject.SequencingData.RequiredForNotSatisfied;
}

function Activity_RollupProgressCompletion () {
    return this.LearningObject.SequencingData.RollupProgressCompletion;
}

function Activity_GetRequiredForCompleted () {
    return this.LearningObject.SequencingData.RequiredForCompleted;
}

function Activity_GetRequiredForIncomplete () {
    return this.LearningObject.SequencingData.RequiredForIncomplete;
}

function Activity_IncrementAttemptCount () {
    this.ActivityAttemptCount += 1;
}

function Activity_SetRandomizedChildren (value) {
    this.RandomizedChildren = value;
    this.SetDirtyData();
}

function Activity_SetSelectedChildren (value) {
    this.SelectedChildren = value;
    this.SetDirtyData();
}

function Activity_GetRandomizedChildren () {
    return this.RandomizedChildren;
}

function Activity_GetSelectedChildren () {
    return this.SelectedChildren;
}

function Activity_GetActivityListBetweenChildren (startActivity, endActivity, includeEndActivity) {
    var activityList = this.GetAvailableChildren(),
        aryReturn = [],
        startActivityIndex = null,
        endActivityIndex = null,
        i;

    for (i = 0; i < activityList.length; i += 1) {
        if (startActivity === activityList[i]) {
            startActivityIndex = i;
        }

        if (endActivity === activityList[i]) {
            endActivityIndex = i;
        }
    }

    if (startActivityIndex === endActivityIndex) {
        if (includeEndActivity) {
            aryReturn[0] = activityList[startActivityIndex];
        }
    }
    else if (startActivityIndex < endActivityIndex) {
        if (includeEndActivity) {
            endActivityIndex += 1;
        }
        aryReturn = activityList.slice(startActivityIndex, endActivityIndex);
    }
    else if (startActivityIndex > endActivityIndex) {
        if (! includeEndActivity) {
            endActivityIndex += 1;
        }

        aryReturn = activityList.slice(endActivityIndex, startActivityIndex + 1);
    }

    return aryReturn;
}

function Activity_IsActivityAnAvailableChild (activity) {
    var availableChildren = this.GetAvailableChildren(),
        i;

    for (i = 0; i < availableChildren.length; i += 1) {
        if (availableChildren[i] === activity) {
            return true;
        }
    }

    return false;
}

function Activity_SearchAllAvailableDescendents (activityToSearch, activityToFind) {
    var availableChildren = activityToSearch.GetAvailableChildren(),
        i;

    for (i = 0; i < availableChildren.length; i += 1) {
        if (availableChildren[i] === activityToFind) {
            return true;
        }
        if (Activity_SearchAllAvailableDescendents(availableChildren[i], activityToFind)) {
            return true;
        }
    }

    return false;
}

function Activity_IsActivityAnAvailableDescendent (activityToFind) {
    return Activity_SearchAllAvailableDescendents(this, activityToFind);
}

function Activity_IsActivityTheLastAvailableChild (activity) {
    var availableChildren = this.GetAvailableChildren();

    if (availableChildren[availableChildren.length - 1] === activity) {
        return true;
    }

    return false;
}

function Activity_IsActivityTheFirstAvailableChild (activity) {
    var availableChildren = this.GetAvailableChildren();

    if (availableChildren[0] === activity) {
        return true;
    }

    return false;
}

function Activity_GetFirstAvailableChild () {
    var availableChildren = this.GetAvailableChildren();

    return availableChildren[0];
}

function Activity_GetNextActivityPreorder () {
    // In a preorder traversal, the next node is either our first child...
    var children = this.GetAvailableChildren(),
        current,
        sibling;

    if (children.length !== 0) {
        return children[0];
    }

    // Or the next sibling of our closest ancestor (ourselves included)
    // with a next sibling (stop if we reach the top of the tree)
    // eslint-disable-next-line consistent-this
    for (current = this; current.ParentActivity !== null; current = current.ParentActivity) {
        sibling = current.GetNextSibling();
        if (sibling !== null) {
            return sibling;
        }
    }

    return null;
}

function Activity_GetPreviousActivityPreorder () {
    //
    // If we have no previous siblings, then our parent is the previous node
    // (Note: if we are the root node, then we have no parent and no previous,
    // so this returns null)
    //
    var previous = this.GetPreviousSibling(),
        nephews;

    if (previous === null) {
        return this.ParentActivity;
    }

    //
    // If we do have a previous sibling, then the previous node is the deepest
    // descendant to the far right of our previous sibling
    //
    nephews = previous.GetAvailableChildren();
    while (nephews.length > 0) {
        previous = nephews[nephews.length - 1];
        nephews = previous.GetAvailableChildren();
    }

    return previous;
}

function Activity_GetNextSibling () {
    var currentActivityIndex = null,
        parentActivity = this.ParentActivity,
        availableChildren,
        i;

    if (parentActivity === null) {
        return null;
    }

    availableChildren = parentActivity.GetAvailableChildren();

    for (i = 0; i < availableChildren.length; i += 1) {
        if (availableChildren[i] === this) {
            currentActivityIndex = i;
            break;
        }
    }

    if (currentActivityIndex !== null && currentActivityIndex < (availableChildren.length - 1)) {
        return availableChildren[currentActivityIndex + 1];
    }

    return null;
}

function Activity_GetPreviousSibling () {
    var currentActivityIndex = null,
        parentActivity = this.ParentActivity,
        availableChildren,
        i;

    if (parentActivity === null) {
        return null;
    }

    availableChildren = parentActivity.GetAvailableChildren();

    for (i = 0; i < availableChildren.length; i += 1) {
        if (availableChildren[i] === this) {
            currentActivityIndex = i;
            break;
        }
    }

    if (currentActivityIndex !== null && currentActivityIndex > 0) {
        return availableChildren[currentActivityIndex - 1];
    }

    return null;
}

function Activity_InitializeAvailableChildren () {
    //
    // go through and find all the children that are included
    // if none are included, then include them all
    //
    var allChildren = this.GetChildren(),
        includedChildren = [],
        i;

    for (i = 0; i < allChildren.length; i += 1) {
        if (allChildren[i].Included === true) {
            includedChildren[includedChildren.length] = allChildren[i];
        }
    }

    if (includedChildren.length === 0) {
        this.SetAvailableChildren(allChildren);
    }
    else {
        // sort the array based on the values of the ordinals
        includedChildren.sort(
            function (activity1, activity2) {
                var ordinal1 = activity1.Ordinal,
                    ordinal2 = activity2.Ordinal;

                if (ordinal1 < ordinal2) {
                    return -1;
                }
                if (ordinal1 > ordinal2) {
                    return 1;
                }

                return 0;
            }
        );
        this.SetAvailableChildren(includedChildren);
    }
}

function Activity_GetAvailableChildren () {
    //
    // we can't initialize these in the constructor because the constructor relies on the
    // ObjectRepository being populated, since the object repository is still being populated
    // when these objects are created, we can't rely on it
    //

    if (this.AvailableChildren === null) {
        this.InitializeAvailableChildren();
    }

    return this.AvailableChildren;
}

function Activity_SetAvailableChildren (childArray) {
    var allChildren,
        i;

    this.AvailableChildren = childArray;

    // reset all included and ordinal fields
    allChildren = this.GetChildren();

    for (i = 0; i < allChildren.length; i += 1) {
        allChildren[i].Ordinal = 0;
        allChildren[i].Included = false;
    }

    for (i = 0; i < this.AvailableChildren.length; i += 1) {
        this.AvailableChildren[i].Ordinal = i + 1;
        this.AvailableChildren[i].Included = true;
    }

    this.SetDirtyData();
}

function Activity_IsAvailable () {
    return this.Included;
}

function Activity_InitializeForNewAttempt (resetObjectives, resetAttemptState) {
    //
    // Initialize Objective Progress Information and Attempt Progress Information required
    // for the new attempt. Initialize tracking information for the new attempt. We need to
    // reset the attempt data if only the current attempt is relevent
    //
    var i,
        objectives,
        children;

    this.AttemptedDuringThisAttempt = false;

    objectives = this.GetObjectives();

    if (resetObjectives && this.LearningObject.SequencingData.UseCurrentAttemptObjectiveInformation === true) {
        resetObjectives = true;

        for (i = 0; i < objectives.length; i += 1) {
            objectives[i].ResetAttemptState();
        }
    }
    else {
        resetObjectives = false;
    }

    if (resetAttemptState && this.LearningObject.SequencingData.UseCurrentAttemptProgressInformation === true) {
        resetAttemptState = true;

        this.ResetAttemptState();
    }
    else {
        resetAttemptState = false;
    }

    children = this.GetChildren();

    for (i = 0; i < children.length; i += 1) {
        children[i].InitializeForNewAttempt(resetObjectives, resetAttemptState);
    }

    if (rscpCfg.get("sspEnabled") && Control.Api.SSPApi) {
        Control.Api.SSPApi.ResetBucketsForActivity(this.DatabaseId);
    }

    this.SetDirtyData();
}

function Activity_ResetAttemptState () {
    this.PrevAttemptProgressStatus = this.AttemptProgressStatus;
    this.PrevAttemptCompletionStatus = this.AttemptCompletionStatus;

    this.AttemptProgressStatus = false;
    this.AttemptCompletionAmountStatus = false;
    this.AttemptCompletionAmount = 0;
    this.AttemptCompletionStatus = false;

    this.SetDirtyData();
}

//
// Rollup Duration information (only handles internal aggregation activities)
// Aggregate nodes take the earliest start timestamp from their children.
// Durations are taken as time of last child ended - earliest start timestamp
//
// eslint-disable-next-line complexity
function Activity_RollupDurations () {
    var EarliestChildActivityStartTimestampUtc = null,
        EarliestChildAttemptStartTimestampUtc = null,
        LatestChildEndDate = null,
        LatestAttChildEndDate = null,
        ChildrenActExperiencedDurationTracked = 0,
        ChildrenActExperiencedDurationReported = 0,
        ChildrenAttExperiencedDurationTracked = 0,
        ChildrenAttExperiencedDurationReported = 0,
        applicableChildren = this.GetChildren(),
        i,
        startActivityDateObj,
        startAttemptDateObj;

    for (i = 0; i < applicableChildren.length; i += 1) {
        // remember earliest child activity start time
        if (applicableChildren[i].GetActivityStartTimestampUtc()) {
            if (! EarliestChildActivityStartTimestampUtc || applicableChildren[i].GetActivityStartTimestampUtc() < EarliestChildActivityStartTimestampUtc) {
                EarliestChildActivityStartTimestampUtc = applicableChildren[i].GetActivityStartTimestampUtc();
            }
        }

        // remember latest child activity end time
        if (applicableChildren[i].ActivityEndedDate) {
            if (! LatestChildEndDate || applicableChildren[i].ActivityEndedDate > LatestChildEndDate) {
                LatestChildEndDate = applicableChildren[i].ActivityEndedDate;
            }
        }

        // track children activity durations
        if (applicableChildren[i].GetActivityExperiencedDurationTracked()) {
            ChildrenActExperiencedDurationTracked += ConvertIso8601TimeSpanToHundredths(applicableChildren[i].GetActivityExperiencedDurationTracked());
        }
        if (applicableChildren[i].GetActivityExperiencedDurationReported()) {
            ChildrenActExperiencedDurationReported += ConvertIso8601TimeSpanToHundredths(applicableChildren[i].GetActivityExperiencedDurationReported());
        }

        // Is this child in the same attempt as this parent? (Did child's attempt start after our attempt start?)
        if (! this.GetAttemptStartTimestampUtc() || (applicableChildren[i].GetAttemptStartTimestampUtc() && applicableChildren[i].GetAttemptStartTimestampUtc() >= this.GetAttemptStartTimestampUtc())) {
            // child is in same attempt

            // remember earliest child activity start time
            if (! this.GetAttemptStartTimestampUtc() && applicableChildren[i].GetAttemptStartTimestampUtc()) {
                if (! EarliestChildAttemptStartTimestampUtc || applicableChildren[i].GetAttemptStartTimestampUtc() < EarliestChildAttemptStartTimestampUtc) {
                    EarliestChildAttemptStartTimestampUtc = applicableChildren[i].GetAttemptStartTimestampUtc();
                }
            }

            if (applicableChildren[i].ActivityEndedDate) {
                if (! LatestAttChildEndDate || applicableChildren[i].ActivityEndedDate > LatestAttChildEndDate) {
                    LatestAttChildEndDate = applicableChildren[i].ActivityEndedDate;
                }
            }
            if (applicableChildren[i].GetAttemptExperiencedDurationTracked()) {
                ChildrenAttExperiencedDurationTracked += ConvertIso8601TimeSpanToHundredths(applicableChildren[i].GetAttemptExperiencedDurationTracked());
            }
            if (applicableChildren[i].GetAttemptExperiencedDurationReported()) {
                ChildrenAttExperiencedDurationReported += ConvertIso8601TimeSpanToHundredths(applicableChildren[i].GetAttemptExperiencedDurationReported());
            }
        }
    }

    //
    // We are only called for aggregation nodes, but it can't harm to check here
    // It is possible that we are called for an aggregation even though none of the
    // children have been loaded, so don't do anything in that case either.
    // (this can happen because of a dependent global objective being set by a
    // separate activity)
    //
    if (! this.IsALeaf() && EarliestChildActivityStartTimestampUtc !== null) {
        this.SetActivityStartTimestampUtc(EarliestChildActivityStartTimestampUtc);

        if (! this.GetAttemptStartTimestampUtc()) {
            this.SetAttemptStartTimestampUtc(EarliestChildAttemptStartTimestampUtc);
        }

        //
        // Aggregate nodes take the earliest start timestamp from their children.
        // Durations are taken as time of last child ended - earliest start timestamp
        //

        this.ActivityEndedDate = LatestChildEndDate;

        startActivityDateObj = GetDateFromUtcIso8601Time(this.GetActivityStartTimestampUtc());
        startAttemptDateObj = GetDateFromUtcIso8601Time(this.GetAttemptStartTimestampUtc());

        this.SetActivityAbsoluteDuration(ConvertHundredthsToIso8601TimeSpan((LatestChildEndDate - startActivityDateObj) / 10));
        this.SetAttemptAbsoluteDuration(ConvertHundredthsToIso8601TimeSpan((LatestAttChildEndDate - startAttemptDateObj) / 10));

        this.SetActivityExperiencedDurationTracked(ConvertHundredthsToIso8601TimeSpan(ChildrenActExperiencedDurationTracked));
        this.SetActivityExperiencedDurationReported(ConvertHundredthsToIso8601TimeSpan(ChildrenActExperiencedDurationReported));
        this.SetAttemptExperiencedDurationTracked(ConvertHundredthsToIso8601TimeSpan(ChildrenAttExperiencedDurationTracked));
        this.SetAttemptExperiencedDurationReported(ConvertHundredthsToIso8601TimeSpan(ChildrenAttExperiencedDurationReported));
    }
}

function Activity_SetDirtyData () {
    this.DataState = DATA_STATE_DIRTY;
}

function Activity_IsAnythingDirty () {
    var i;

    if (this.DataState === DATA_STATE_DIRTY) {
        return true;
    }

    for (i = 0; i < this.ActivityObjectives.length; i += 1) {
        if (this.ActivityObjectives[i].DataState === DATA_STATE_DIRTY) {
            return true;
        }
    }

    return false;
}

function Activity_MarkPostedObjectiveDataDirty () {
    var i;

    for (i = 0; i < this.ActivityObjectives.length; i += 1) {
        if (this.ActivityObjectives[i].DataState === DATA_STATE_POSTED) {
            this.ActivityObjectives[i].SetDirtyData();
        }
    }
}

function Activity_MarkPostedObjectiveDataClean () {
    var i;

    for (i = 0; i < this.ActivityObjectives.length; i += 1) {
        if (this.ActivityObjectives[i].DataState === DATA_STATE_POSTED) {
            this.ActivityObjectives[i].DataState = DATA_STATE_CLEAN;
        }
    }
}

function Activity_MarkDirtyObjectiveDataPosted () {
    var i;

    for (i = 0; i < this.ActivityObjectives.length; i += 1) {
        if (this.ActivityObjectives[i].DataState === DATA_STATE_DIRTY) {
            this.ActivityObjectives[i].DataState = DATA_STATE_POSTED;
        }
    }
}

function Activity_SetSequencer (sequencer, isLookAhead) {
    var i;

    this.Sequencer = sequencer;
    this.LookAheadActivity = isLookAhead;

    for (i = 0; i < this.ActivityObjectives.length; i += 1) {
        this.ActivityObjectives[i].SetSequencer(sequencer);
    }
}

function Activity_Clone () {
    var clone = new Activity(
            this.DatabaseId,
            this.ItemIdentifier,
            this.ScormObjectDatabaseId,
            this.ActivityProgressStatus,
            this.ActivityAttemptCount,
            this.AttemptProgressStatus,
            this.AttemptCompletionAmountStatus,
            this.AttemptCompletionAmount,
            this.AttemptCompletionStatus,
            this.Active,
            this.Suspended,
            this.Included,
            this.Ordinal,
            this.SelectedChildren,
            this.RandomizedChildren,
            null,
            null,
            this.PrevAttemptProgressStatus,
            this.PrevAttemptCompletionStatus,
            this.AttemptedDuringThisAttempt,
            this.FirstCompletionTimestampUtc,
            this.ActivityStartTimestampUtc,
            this.AttemptStartTimestampUtc,
            this.ActivityAbsoluteDuration,
            this.AttemptAbsoluteDuration,
            this.ActivityExperiencedDurationTracked,
            this.AttemptExperiencedDurationTracked,
            this.ActivityExperiencedDurationReported,
            this.AttemptExperiencedDurationReported
        ),
        objectiveId;

    clone.StringIdentifier = this.toString();

    clone.ActivityObjectives = [];
    for (objectiveId in this.ActivityObjectives) {
        if (this.ActivityObjectives.hasOwnProperty(objectiveId)) {
            clone.ActivityObjectives[objectiveId] = this.ActivityObjectives[objectiveId].Clone();
        }
    }

    clone.RunTime = this.RunTime;
    clone.LearningObject = this.LearningObject;

    clone.DataState = DATA_STATE_CLEAN;

    clone.LaunchedThisSession = this.LaunchedThisSession;
    clone.AttemptedDuringThisAttempt = this.AttemptedDuringThisAttempt;
    clone.UsesDefaultRollupRules = this.UsesDefaultRollupRules;

    return clone;
}

function Activity_TearDown () {
    var objectiveId;

    this.StringIdentifier = null;
    this.DatabaseId = null;
    this.ScormObjectDatabaseId = null;
    this.ActivityProgressStatus = null;
    this.ActivityAttemptCount = null;
    this.AttemptProgressStatus = null;
    this.AttemptCompletionAmountStatus = null;
    this.AttemptCompletionAmount = null;
    this.AttemptCompletionStatus = null;
    this.FirstCompletionTimestampUtc = null;
    this.ActivityStartTimestampUtc = null;
    this.AttemptStartTimestampUtc = null;
    this.ActivityAbsoluteDuration = null;
    this.AttemptAbsoluteDuration = null;
    this.ActivityExperiencedDurationTracked = null;
    this.AttemptExperiencedDurationTracked = null;
    this.ActivityExperiencedDurationReported = null;
    this.AttemptExperiencedDurationReported = null;
    this.Active = null;
    this.Suspended = null;
    this.Included = null;
    this.Ordinal = null;
    this.SelectedChildren = null;
    this.RandomizedChildren = null;
    this.RunTime = null;
    this.Sequencer = null;
    this.LookAheadActivity = null;
    this.LearningObject = null;
    this.ParentActivity = null;
    this.AvailableChildren = null;
    this.DataState = null;
    this.MenuItem = null;
    this.ChildActivities = null;
    this.CachedPrimaryObjective = null;
    this.HiddenFromChoice = null;

    for (objectiveId in this.ActivityObjectives) {
        if (this.ActivityObjectives.hasOwnProperty(objectiveId)) {
            this.ActivityObjectives[objectiveId].TearDown();
            this.ActivityObjectives[objectiveId] = null;
        }
    }

    this.ActivityObjectives = null;
}

function Activity_DisplayInChoice () {
    if (this.LearningObject.Visible === false) {
        return false;
    }
    else if (this.IsAvailable() === false) {
        return false;
    }
    else if (this.HiddenFromChoice === true) {
        return false;
    }

    return true;
}

function Activity_SetHiddenFromChoice (blnArg) {
    this.HiddenFromChoice = blnArg;
}

function Activity_WasLaunchedThisSession () {
    return this.LaunchedThisSession;
}

function Activity_SetLaunchedThisSession () {
    /* globals SCORM_TYPE_ASSET */
    this.LaunchedThisSession = true;

    if (this.LearningObject.ScormType === SCORM_TYPE_ASSET) {
        Control.ScoLoader.ScoLoaded = true;
    }
}

function Activity_WasAttemptedDuringThisAttempt () {
    return this.AttemptedDuringThisAttempt;
}
function Activity_SetAttemptedDuringThisAttempt () {
    this.AttemptedDuringThisAttempt = true;
}

function Activity_GetMinProgressMeasure () {
    // value is called CompletionThreshhold for backwards compatibility and runtime use
    return this.LearningObject.CompletionThreshold;
}

function Activity_GetCompletionProgressWeight () {
    return parseFloat(this.LearningObject.CompletionProgressWeight);
}

function Activity_GetCompletedByMeasure () {
    return this.LearningObject.CompletedByMeasure;
}

function Activity_GetAttemptCompletionAmount () {
    return this.AttemptCompletionAmount;
}
function Activity_SetAttemptCompletionAmount (value) {
    this.AttemptCompletionAmount = value;
}

function Activity_GetAttemptCompletionAmountStatus () {
    return this.AttemptCompletionAmountStatus;
}

function Activity_SetAttemptCompletionAmountStatus (value) {
    this.AttemptCompletionAmountStatus = value;
}

function Activity_GetCompletionStatusChangedDuringRuntime () {
    if (this.RunTime !== null) {
        return this.RunTime.CompletionStatusChangedDuringRuntime;
    }

    return false;
}

function Activity_GetSuccessStatusChangedDuringRuntime () {
    if (this.RunTime !== null) {
        return this.RunTime.SuccessStatusChangedDuringRuntime;
    }

    return false;
}

function Activity_GetActivityStartTimestampUtc () {
    return this.ActivityStartTimestampUtc;
}

function Activity_SetActivityStartTimestampUtc (value) {
    this.ActivityStartTimestampUtc = value;
    this.SetDirtyData();
}

function Activity_GetAttemptStartTimestampUtc () {
    return this.AttemptStartTimestampUtc;
}

function Activity_SetAttemptStartTimestampUtc (value) {
    this.AttemptStartTimestampUtc = value;
    this.SetDirtyData();
}

function Activity_GetActivityAbsoluteDuration () {
    return this.ActivityAbsoluteDuration;
}

function Activity_SetActivityAbsoluteDuration (value) {
    this.ActivityAbsoluteDuration = value;
    this.SetDirtyData();
}

function Activity_GetAttemptAbsoluteDuration () {
    return this.AttemptAbsoluteDuration;
}

function Activity_SetAttemptAbsoluteDuration (value) {
    this.AttemptAbsoluteDuration = value;
    this.SetDirtyData();
}

function Activity_GetActivityExperiencedDurationTracked () {
    return this.ActivityExperiencedDurationTracked;
}

function Activity_SetActivityExperiencedDurationTracked (value) {
    this.ActivityExperiencedDurationTracked = value;
    this.SetDirtyData();
}

function Activity_GetAttemptExperiencedDurationTracked () {
    return this.AttemptExperiencedDurationTracked;
}

function Activity_SetAttemptExperiencedDurationTracked (value) {
    this.AttemptExperiencedDurationTracked = value;
    this.SetDirtyData();
}

function Activity_GetActivityExperiencedDurationReported () {
    return this.ActivityExperiencedDurationReported;
}

function Activity_SetActivityExperiencedDurationReported (value) {
    this.ActivityExperiencedDurationReported = value;
    this.SetDirtyData();
}

function Activity_GetAttemptExperiencedDurationReported () {
    return this.AttemptExperiencedDurationReported;
}

function Activity_SetAttemptExperiencedDurationReported (value) {
    this.AttemptExperiencedDurationReported = value;
    this.SetDirtyData();
}

function Activity_UsesDefaultSatisfactionRollupRules () {
    return this.LearningObject.UsesDefaultSatisfactionRollupRules;
}

function Activity_UsesDefaultCompletionRollupRules () {
    return this.LearningObject.UsesDefaultCompletionRollupRules;
}
